export default __webpack_public_path__ + "static/media/Sid at Panch ratha.41393f4b.jpg";